import { createBlock, createMutableBlock } from '@/(routers)/boards/editor/block/blockFactory';
import type { BlockDef, MutableBlockDef } from '@/(routers)/boards/editor/block/blockFactory';

export const BLOCK_TYPES: Record<string, string> = {};
export const BLOCK_TEXT_COLOURS: Record<string, string> = {};

export function defineBlock(def: BlockDef): void {
    BLOCK_TYPES[def.type] = def.type;
    if (def.textColour) BLOCK_TEXT_COLOURS[def.type] = def.textColour;
    createBlock(def);
}

export function defineMutableBlock(def: MutableBlockDef): void {
    BLOCK_TYPES[def.type] = def.type;
    if (def.textColour) BLOCK_TEXT_COLOURS[def.type] = def.textColour;
    createMutableBlock(def);
}
